import { Text, Texture } from "pixi.js";
import { LatestNewsResourcePackage } from "../../resources/LatestNewsResourcePackage";
import { CurrencyType, NewsCurrencyComponent } from "../NewsCurrencyComponent";
import { NewsTextStyle } from "../styles/NewsTextStyle";
import { INewsItemOptions } from "./NewsItem";
import { UserProfileResourcePackage } from "../../../userprofile/resources/UserProfileResourcePackage";
import { NewsItemWithAvatar } from "./NewsItemWithAvatar";

export class NewsItemRenterUpgraded extends NewsItemWithAvatar {
    private static readonly UPGRADED_TEXT = 'UPGRADED YOUR BUILDING AT';
    private static readonly YOU_EARNED_TEXT = 'YOU EARNED ';

    private nameText: Text;
    private fixedText: Text;
    private addressText: Text;
    private youEarnedText: Text;
    private currencyComponent: NewsCurrencyComponent;

    public constructor(
        id: string,
        newsResources: LatestNewsResourcePackage,
        userProfileResources: UserProfileResourcePackage,
        options: NewsItemRenterUpgradedOptions
    ) {
        super(
            id,
            newsResources,
            userProfileResources,
            newsResources.assets_views_latest_news_news_tooltip_blue_png,
            newsResources.assets_views_latest_news_news_token_upgrade_png,
            options.playerAvatarTexture
        );
        this.build(options);
        this.layout();
    }

    private build(options: NewsItemRenterUpgradedOptions): void {
        this.nameText = new Text(options.playerName, new NewsTextStyle());
        this.fixedText = new Text(NewsItemRenterUpgraded.UPGRADED_TEXT, new NewsTextStyle());
        this.addressText = new Text(options.address, new NewsTextStyle());
        this.youEarnedText = new Text(NewsItemRenterUpgraded.YOU_EARNED_TEXT, new NewsTextStyle());
        this.currencyComponent = new NewsCurrencyComponent(this.newsResources, options.currencyNumber, CurrencyType.TOKEN);
        this.avatar.updateTexture(options.playerAvatarTexture);

        this.addChild(this.nameText, this.fixedText, this.addressText, this.youEarnedText, this.currencyComponent);
    }

    private layout(): void {
        this.nameText.position.set(411, 29);
        this.fixedText.position.set(411, 72);
        this.addressText.position.set(411, 115);
        this.youEarnedText.position.set(411, 158);
        this.currencyComponent.position.set(550, 158);
    }
}

export class NewsItemRenterUpgradedOptions implements INewsItemOptions {
    public readonly playerName: string;
    public readonly playerAvatarTexture: Texture;
    public readonly address: string;
    public readonly currencyNumber: number;

    public constructor(playerName: string, playerAvatarTexture: Texture, address: string, currencyNumber: number) {
        this.playerName = playerName;
        this.playerAvatarTexture = playerAvatarTexture;
        this.address = address;
        this.currencyNumber = currencyNumber;
    }
}